import React from "react";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";
import Review from "../Components/Feed/review";

const SIngleReview = () => {
  return (
    <div>
      <Navbar />
      <Review />
      <Footer />
    </div>
  );
};

export default SIngleReview;
